import React, { useEffect, useRef } from 'react';
import { Button } from '@zurich-primitives/button';
import styles from './ComparisonResult.module.scss';

interface Props {
  position: { top: number; left: number };
  value: string;
  onChange: (text: string) => void;
  onConfirm: () => void;
  onCancel: () => void;
}

export const AnnotationPopover: React.FC<Props> = ({
  position,
  value,
  onChange,
  onConfirm,
  onCancel,
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    textareaRef.current?.focus();
  }, []);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
      e.preventDefault();
      onConfirm();
    }
    if (e.key === 'Escape') {
      onCancel();
    }
  };

  return (
    <div
      className={styles['annotation-popover']}
      style={{ top: position.top, left: position.left }}
    >
      <textarea
        ref={textareaRef}
        className={styles['annotation-popover__textarea']}
        placeholder="Add a comment…"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        rows={3}
      />
      <div className={styles['annotation-popover__actions']}>
        <Button variant="tertiary" size="small" onClick={onCancel}>
          <Button.Label>Cancel</Button.Label>
        </Button>
        <Button
          variant="primary"
          size="small"
          onClick={onConfirm}
          disabled={!value.trim()}
        >
          <Button.Label>Save</Button.Label>
        </Button>
      </div>
    </div>
  );
};
